import { Location } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DebatesService } from './debates.service';

@Component({
  selector: 'lms-mars1-debates',
  templateUrl: './mars1-debates.component.html',
  styleUrls: ['./mars1-debates.component.scss']
})
export class Mars1DebatesComponent implements OnInit {
  @Input() listId: string;
  @Input() groupId: string;
  @Input() options: any;
  public debates: any[];
  public stats: any;

  constructor(
    public route: ActivatedRoute,
    public location: Location,
    public debatesService: DebatesService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.debatesService.getDebatesStats({ groupId: this.groupId }).subscribe((stats) => {
      this.stats = stats;
    });
  }

  setCollection(collection) {
    if (collection) {
      this.debates = collection;
    }
  }
}
